import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchIncomeTaxSummaryTypes = getApiActionTypes('FETCH_INCOME_TAX_SUMMARY');
export const fetchFranchiseTaxSummaryTypes = getApiActionTypes('FETCH_FRANCHISE_TAX_SUMMARY');
export const fetchEstimatedTaxSummaryTypes = getApiActionTypes('FETCH_ESTIMATED_TAX_SUMMARY');
